import {
    IonButton,
    IonCol,
    IonItem,
    IonLabel,
    IonRow,
    IonToggle,
} from "@ionic/react";
import React, { useEffect, useState } from "react";
import { UpdateEventInput } from "../../API";
import { EntryOptions, Event } from "../../models";
import { updateEvent } from "../../utilities/events/Event";
import ErrorAlert from "../Errors/ErrorAlert";
import Spinner from "../Spinners/Spinner";

interface _Props {
    event: Event
}

const EventCogginsSettingsForm: React.FC<_Props> = ({event}) => {

    const [requireDocument, setRequireDocument] = useState(false);
    const [requireDataInput, setRequireDataInput] = useState(false);

    const [isDisabled, setIsDisabled] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string>("");

    useEffect(() => {
        if (event) {
            if (event.entryOptions?.requiresCogginsData) setRequireDataInput(true);
            if (event.entryOptions?.requiresCogginsDocument) setRequireDocument(true);
        }
    }, [event]);

    const handleSave = async () => {
        const entryOptions: EntryOptions = {
            requiresCogginsDocument: requireDocument,
            requiresCogginsData: requireDataInput
        }
        const input: UpdateEventInput = {
            id: event.id,
            entryOptions: entryOptions
        };
        const updateResult = await updateEvent(input);
        if (updateResult.isSuccess) {
            setIsDisabled(true);
        } else {
            setError("Could not save the Entry Settings.");
        }
    }

    const handleSubmit = async () => {
        setIsLoading(true);
        setError("");
        await handleSave();
        setIsLoading(false);
    }

    return (
        <>
            {error && <ErrorAlert width="12" error={error}/>}
            <IonRow>
                <IonCol size="12">
                    <IonItem lines="none">
                        <IonLabel slot="start" className="ion-text-wrap">Require Coggins Data Input</IonLabel>
                        {/* <p className="text-light">Require each entry to include the date, state, and accession number of the current coggins.</p> */}
                        <IonToggle color="tertiary" checked={requireDataInput} onIonChange={e => {setRequireDataInput(e.detail.checked); setIsDisabled(false);}}/>
                    </IonItem> 
                </IonCol>
            </IonRow>
            <IonRow>
                <IonCol size="12">
                    <IonItem lines="none">
                        <IonLabel slot="start" className="ion-text-wrap">Require Coggins Document</IonLabel>
                        {/* <p className="text-light">Require each entry to include a PDF or image upload of their coggins document.</p> */}
                        <IonToggle color="tertiary" checked={requireDocument} onIonChange={e => {setRequireDocument(e.detail.checked); setIsDisabled(false);}}/>
                    </IonItem> 
                </IonCol>
            </IonRow>
            <IonRow>
                <IonCol sizeMd="4">
                    {isLoading ?
                        <Spinner />
                        :
                        <IonButton
                            disabled={isDisabled}
                            className="ion-margin-top"
                            color="tertiary"
                            expand="block"
                            onClick={handleSubmit}
                        >
                            {isDisabled ? "Saved" : "Save"}
                        </IonButton>
                    }
                </IonCol>
            </IonRow>
        </>
    );
};

export default EventCogginsSettingsForm;